// ------------------------------------
// Constants
// ------------------------------------

export const CLOSE_ADDED_TO_CART = 'farmakom/addedToCart/CLOSE_ADDED_TO_CART';
import { ADD_TO_CART_SUCCESS } from './cart';

// ------------------------------------
// Actions
// ------------------------------------

export function closeAddedToCart() {
  return {
    type: CLOSE_ADDED_TO_CART,
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  addedToCartOpen: false,
  productImage: '',
};

export default function addedToCartReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        addedToCartOpen: !action.payload.product.isFreeCorrelatedProduct,
        productImage: action.payload.image,
      };

    case CLOSE_ADDED_TO_CART:
      return initialState;

    default:
      return state;
  }
}

// ------------------------------------
// Selectors
// ------------------------------------
